import { render } from "./DBLinkedData.vue?vue&type=template&id=07d34d90&scoped=true&ts=true"
import script from "./DBLinkedData.vue?vue&type=script&lang=ts"
export * from "./DBLinkedData.vue?vue&type=script&lang=ts"

import "./DBLinkedData.vue?vue&type=style&index=0&id=07d34d90&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d34d90"]])

export default __exports__